<template>
  <div v-if="renderParams.agent">
    <div v-if="version === 'table'">
      <div class="agent-mobile d-sm-flex align-items-center d-none d-sm-block">
        <div class="container">
          <div class="info d-flex justify-content-center align-items-center">
            <div class="text-right name-block">
              <div class="header">{{ yourAgent }}</div>
              <a href="#" class="name d-block">{{ agentName }}</a>
              <div class="agency">{{ renderParams.agency }}</div>
            </div>

            <div class="img-fluid portrait" :style="agentPhotoStyle" />

            <div class="text-left contacts">
              <div>{{ contacts }}</div>
              <a :href="`tel: ${agentPhone}`" class="phone d-block">{{
                agentPhone
              }}</a>
              <a :href="`mailto: ${agentEmail}`" class="email d-block">{{
                agentEmail
              }}</a>
              <Shareon v-if="renderParams.config.isShareon" />
            </div>
          </div>
        </div>
      </div>

      <div class="agent d-block d-sm-none">
        <div class="container">
          <div class="info">
            <div class="header">{{ yourAgent }}</div>

            <div class="portrait" :style="agentPhotoStyle" />

            <a href="#" class="name text-center d-block">{{ agentName }}</a>
            <div class="agency text-center">{{ renderParams.agency }}</div>
            <hr />

            <div class="contacts">
              <a :href="`tel: ${agentPhone}`" class="phone">{{ agentPhone }}</a>
              <br />
              <a :href="`mailto: ${agentEmail}`" class="email">{{
                agentEmail
              }}</a>
            </div>

            <Shareon v-if="renderParams.config.isShareon" />
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="version === 'print'">
      <div class="agent">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <img :src="agentPhotoFullUrl" class="img-fluid portrait" />
            <div>
              <div class="name">{{ agentName }}</div>
              <div class="agency">{{ renderParams.agency }}</div>
            </div>
          </div>

          <div class="text-center text-xl-left contact-info">
            <div class="d-flex flex-column">
              <div v-if="agentPhone" class="phone">
                <img src="/images/phone.svg" class="Phone print-phone" />
                {{ agentPhone }}
              </div>
            </div>
            <div class="email d-flex">
              <img src="/images/mail.svg" class="Mail" />
              {{ agentEmail }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else-if="version === 'standard' && location === 'right'"
      class="agent d-sm-none d-lg-block"
    >
      <div class="info">
        <div class="header">{{ yourAgent }}</div>
        <div class="portrait" :style="agentPhotoStyle" />
        <a href="#" class="name d-block">{{ agentName }}</a>
        <div class="agency">{{ renderParams.agency }}</div>
        <hr />
        <div class="contacts">
          <div class="d-flex flex-column">
            <a v-if="agentPhone" :href="`tel:${agentPhone}`" class="phone">
              {{ agentPhone }}
            </a>
          </div>
          <a :href="`mailto: ${agentEmail}`" class="email">{{ agentEmail }}</a>
        </div>
        <CompanyLogo
          v-if="logoHost"
          :logoHost="logoHost"
          :customClass="'logo'"
        />
        <Shareon v-if="renderParams.config.isShareon" />
      </div>
    </div>

    <div
      v-else-if="version === 'standard' && location === 'bottom'"
      class="container"
    >
      <div class="info d-flex justify-content-center align-items-center">
        <div class="text-right name-block">
          <div class="header">{{ yourAgent }}</div>
          <a href="#" class="name d-block">{{ agentName }}</a>
          <div class="agency">{{ renderParams.agency }}</div>
          <CompanyLogo
            v-if="logoHost"
            :logoHost="logoHost"
            :customClass="'logo-tablet'"
            class="d-flex justify-content-center align-items-center"
          />
        </div>
        <div class="img-fluid portrait" :style="agentPhotoStyle" />
        <div class="text-left contacts">
          <div>{{ contacts }}</div>
          <a :href="`tel:${agentPhone}`" class="phone d-block">{{
            agentPhone
          }}</a>
          <a :href="`mailto: ${agentEmail}`" class="email d-block">{{
            agentEmail
          }}</a>
          <Shareon v-if="renderParams.config.isShareon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Shareon from './Shareon.vue'
import CompanyLogo from './CompanyLogo.vue'
import Locale from '../../../services/locale'

export default {
  name: 'PersonalAgent',
  props: {
    renderParams: Object,
    version: String,
    location: String,
    localeService: Locale,
  },
  components: {
    Shareon,
    CompanyLogo,
  },
  computed: {
    contacts() {
      return this.localeService.getConstantTranslationByKey('contacts')
    },
    yourAgent() {
      return this.localeService.getConstantTranslationByKey('your-agent')
    },
    logoHost() {
      return this.renderParams.logoHost
    },
    agentName() {
      return this.renderParams.agent.name
    },
    agentEmail() {
      return this.renderParams.agent.email
    },
    agentPhotoUrl() {
      return this.renderParams.agent.photo
    },
    agentPhone() {
      return this.renderParams.agent.phone
    },
    isAgentPhotoExists() {
      return this.agentPhotoUrl && !this.agentPhotoUrl.includes('Prof')
    },
    agentPhotoFullUrl() {
      if (!this.isAgentPhotoExists) return this.agentPhotoUrl
      if (this.agentPhotoUrl?.includes('cdn.winwinapp.ru/users')) {
        return this.agentPhotoUrl
      }
      return `https://${this.renderParams.config.domain}.amocrm.ru${this.agentPhotoUrl}`
    },
    agentPhotoStyle() {
      return {
        background: `url("${this.agentPhotoFullUrl}") no-repeat center / cover`,
      }
    },
  },
}
</script>

<style scoped>
.print-phone {
  display: initial;
}

@media (max-width: 991px) {
  body.presentation-standard-view .logo,
  body.presentation-standard-view .logo-tablet {
    display: none !important;
  }
}

body.presentation-standard-view .contacts a {
  font-weight: 700;
}
body.presentation-standard-view .text-left,
body.presentation-table-view .text-left {
  text-align: left !important;
}
</style>
